module.exports = __webpack_public_path__ + "img/index3.262f845f.png";